// extracted by mini-css-extract-plugin
export var backdropBlur = "_lk-0";
export var contentCard = "_lk-5";
export var frame = "_lk-2";
export var image = "_lk-4";
export var imagePane = "_lk-3";
export var modal = "_lk-1";